// extracted by mini-css-extract-plugin
export default {"strong":"ReviewParentChildRelationship_strong__8wbFX","summary":"ReviewParentChildRelationship_summary__P89+b","wysiwyg":"ReviewParentChildRelationship_wysiwyg__6Wk7Z"};